import { AnySourceStream, AnySubscription, Stream } from '../stream'
import { Pass } from './pass'

export class TakeUntil<V = any, E = any, C = any, N2 = V> extends Pass<V, E, C, V, E, C | N2 | undefined> {
    protected signal: Stream

    protected signalSubscription: AnySubscription = {
        value: (value: N2) => this._complete(value),
        complete: () => this._complete(undefined),
        error: () => this._complete(undefined),
    }

    constructor(signal: Stream<any, any, any, N2, any, any>, source?: AnySourceStream<V, E, C>) {
        super(source)
        this.signal = signal
    }

    connect() {
        super.connect()
        this.signal.subscribe(this.signalSubscription)
    }

    disconnect() {
        super.disconnect()
        this.signal.unsubscribe(this.signalSubscription)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        takeUntil(signal: Stream): Stream<DV, DE, DC | undefined, DV, DE, DC | undefined>
    }
}

Stream.prototype.takeUntil = function <V, E, C>(this: AnySourceStream<V, E, C>, signal: Stream) {
    return new TakeUntil(signal, this) // tslint:disable-line:no-invalid-this
}
